module.exports = __webpack_public_path__ + "img/07ffe26b882dbbe2c5f0fef4c23b50f6.359b25f9.png";